import React from "react"
import PropTypes from "prop-types"
import {injectIntl} from "@irati/utils/lang"
import styled from "styled-components"
import {get} from "lodash"

import {Select} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"

const PROPERTY = "savings.userSavings.type"

export const OPTIONS = (formatMessage) => [
  {value: "percentage", label: formatMessage({id: "admin.components.card.savingsType.options.label.percentage"})},
  {value: "currency", label: formatMessage({id: "admin.components.card.savingsType.options.label.currency"})}
]

const StyledSelect = styled(Select)`
  text-align: left;
`

export const schema = Validation.string()

const SavingsType = ({benefit, onChange, formatMessage, ...props}) => {
  return (
    <StyledSelect
      name={PROPERTY}
      value={get(benefit, `${PROPERTY}`, null)}
      options={OPTIONS(formatMessage)}
      onChange={(value) => onChange(PROPERTY, value)}
      {...props}
      id={id(PROPERTY, props)} />
  )
}

SavingsType.propTypes = {
  benefit: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  formatMessage: PropTypes.func.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  validation: PropTypes.object
}

SavingsType.defaultProps = {
  required: false,
  placeholder: "",
  label: "admin.components.card.savingsType.label",
  validation: schema,
  isClearable: true,
  id: "benefit"
}

export default injectIntl(SavingsType)
